export enum ValidationType {
  Data,
  Duplicated,
  Format,
  Length,
  Limits,
  RequiredData
}
